export const getAutoSelectedAndDisabledNodes = (treeNodes, selectedNodeIds) => {
    const disabledSet = new Set();
    const selectedSet = new Set(selectedNodeIds);

    const traverse = (node) => {
        if (!node.children || node.children.length === 0) return;

        node.children.forEach(childId => {
            const childNode = treeNodes[childId];
            if (childNode) {
                traverse(childNode);
            }
        });

        // Check if all children are selected
        const allChildrenSelected = node.children.every(childId => {
            const childNode = treeNodes[childId];
            return childNode && selectedSet.has(childNode.accountId);
        });

        if (allChildrenSelected && selectedSet.has(node.accountId)) {
            node.children.forEach(childId => disabledSet.add(childId));
        }
    };

    // Start traversal from root nodes
    Object.values(treeNodes)
        .filter(n => n.data?.parentId === 0)
        .forEach(root => traverse(root));

    return {
        disabled: Array.from(disabledSet)
    };
}